import Vue from 'vue'
import Vuex from 'vuex'
import i18n from './modules/i18n'
import authentication from './modules/authentication'
import user from './modules/user'
import tour from './modules/tour'
import organization from './modules/organization'
import campaign from './modules/campaign'
import audiofile from './modules/audiofile'
import dialplan from './modules/dialplan'
import subscriberDb from './modules/subscriber-db'
import file from './modules/file'
import vccConf from './modules/vcc-conf'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    i18n,
    authentication,
    user,
    tour,
    organization,
    subscriberDb,
    campaign,
    file,
    dialplan,
    audiofile,
    vccConf
  },
  strict: debug,
  plugins: [createPersistedState({paths: ['authentication']})]
})



// WEBPACK FOOTER //
// ./src/store/index.js